import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
// import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { EmployeesListService } from '../employees/employees-list.service';
import { AppointmentModel } from '../agendapro/appointment.model';
import { AgendaProService } from '../agendapro/agendapro.service';
import { ConceptModel } from '../concept/concept/concept.model';
import { ContactModel } from '../contact/contact/contact.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Option } from '../../shared/models/option.model';

@Component({
    selector: 'app-add-appointment-dialog',
    templateUrl: './add-appointment-dialog.component.html',
    styleUrls: ['./agendapro.component.css'],
    standalone: false
})
export class AddAppointmentDialogComponent implements OnInit {

  @Input() mode: 'dialog' | 'panel' | 'page' = 'dialog';
  form: UntypedFormGroup;
  contacts: ContactModel[] = [];
  filteredContacts: ContactModel[] = [];
  contactCtrl: UntypedFormControl = new UntypedFormControl();
  employees: any[] = [];
  concepts: ConceptModel[] = [];

  public get conceptsOptions(): Option[] {
    return (this.concepts || []).map(c => ({ label: c.name, value: c.uid }));
  }

  public get employeesOptions(): Option[] {
    return (this.employees || []).map(e => ({ label: e.name, value: e.uid }));
  }
  allowNewContact: boolean = false;
  createContactOption: ContactModel = new ContactModel();

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private employeeService: EmployeesListService,
    private agendaProService: AgendaProService,
    @Optional() public dialogRef: MatDialogRef<AddAppointmentDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.fb.group({
      contactUid: [null, Validators.required],
      conceptUid: [null, Validators.required],
      employeeId: [null, Validators.required],
      date: [null, Validators.required],
      startTime: [null, Validators.required],
      endTime: [null, Validators.required],
      notes: ['']
    });
  }

  ngOnInit(): void {
    if (this.data && this.data.contacts) {
      this.contacts = this.data.contacts;
      this.filteredContacts = this.contacts.slice();
    }

    if (this.data && this.data.concepts) {
      this.concepts = this.data.concepts;
    }

    this.loadEmployees();

    // Filtro de contactos
    this.contactCtrl.valueChanges.subscribe(val => {
      if (!val) {
        this.filteredContacts = this.contacts.slice();
      } else {
        const filterValue = typeof val === 'string' ? val.toLowerCase() : (val.companyName ? val.companyName.toLowerCase() : '');
        this.filteredContacts = this.contacts.filter(function (c) {
          return c.companyName.toLowerCase().indexOf(filterValue) !== -1;
        });
      }
    });

    // Asignar UID del contacto seleccionado
    this.contactCtrl.valueChanges.subscribe(val => {
      if (val && typeof val === 'object' && val.uid) {
        this.form.get('contactUid').setValue(val.uid);
      }
    });
  }

  handleContactFilter(val: any): void {
    const self = this;

    if (!val) {
      this.filteredContacts = this.contacts.slice();
      this.allowNewContact = false;
      return;
    }

    let filterValue = '';
    if (typeof val === 'string') {
      filterValue = val.toLowerCase();
    } else if (val.companyName) {
      filterValue = val.companyName.toLowerCase();
    }

    // Filtrar clientes
    this.filteredContacts = this.contacts.filter(function (c) {
      return c.companyName.toLowerCase().indexOf(filterValue) !== -1;
    });

    // Si no existe coincidencia exacta → permitir crear nuevo
    const exists = this.contacts.some(function (c) {
      return c.companyName.toLowerCase() === filterValue;
    });

    if (!exists && filterValue.length > 1) {
      this.allowNewContact = true;
      this.createContactOption = new ContactModel();
      this.createContactOption.companyName = val;
    } else {
      this.allowNewContact = false;
    }

    // Si selecciona un objeto existente → actualiza UID
    if (typeof val === 'object' && val.uid) {
      self.form.get('contactUid').setValue(val.uid);
    } else if (this.allowNewContact) {
      self.form.get('contactUid').setValue(null);
    }
  }

  displayContact(contact: ContactModel): string {
    if (!contact) {
      return '';
    }
    return contact.companyName;
  }

  loadEmployees(): void {
    const self = this;
    this.employeeService.getList()
      .then(function (res) {
        self.employees = res || [];
      })
      .catch(function () {
        self.employees = [];
      });
  }

  createNewContact(): ContactModel {
    const newContact = new ContactModel();
    newContact.companyName = this.createContactOption.companyName;
    newContact.uid = 'temp-' + Math.floor(Math.random() * 10000);
    this.contacts.push(newContact);
    return newContact;
  }

  onCancel(): void {
    if (this.mode === 'dialog' || this.mode === 'panel') {
      if (this.dialogRef) {
        this.dialogRef.close(null);
      }
    } else if (this.mode === 'page') {
      this.router.navigate(['/appointments']);
    }
  }

  onSave(): void {
    if (this.form.invalid) {
      return;
    }

    const value = this.form.value;

    // Si el cliente no existe aún, crearlo
    if (this.allowNewContact && this.createContactOption.companyName) {
      const newContact = this.createNewContact();
      value.contactUid = newContact.uid;
    }

    if (this.mode === 'dialog' || this.mode === 'panel') {
      if (this.dialogRef) {
        this.dialogRef.close(value);
      }
    } else if (this.mode === 'page') {
      this.router.navigate(['/appointments']);
    }
  }

  // form: FormGroup;
  // concepts: ConceptModel[] = [];
  // contacts: ContactModel[] = [];
  // filteredContacts: ContactModel[] = [];
  // employees: any[] = [];
  // contactCtrl: FormControl = new FormControl();
  // loading: boolean = false;

  // constructor(
  //   private fb: FormBuilder,
  //   // private dialogRef: MatDialogRef<AddAppointmentDialogComponent>,
  //   private employeeService: EmployeesListService,
  //   private agendaProService: AgendaProService,
  //   // @Inject(MAT_DIALOG_DATA) public data: any
  // ) { }

  // ngOnInit(): void {
  //   // const selectedDate = this.data && this.data.date ? new Date(this.data.date) : new Date();

  //   // this.concepts = this.data.concepts || [];
  //   // this.contacts = this.data.contacts || [];

  //   this.form = this.fb.group({
  //     conceptUid: [null, Validators.required],
  //     employeeId: [null, Validators.required],
  //     contactUid: [null, Validators.required],
  //     date: null,//[selectedDate, Validators.required],
  //     startTime: null,// [this.getDefaultStartTime(selectedDate), Validators.required],
  //     endTime: null,// [this.getDefaultEndTime(selectedDate), Validators.required],
  //     notes: ['']
  //   });

  //   // Inicializamos filteredContacts con todos los contactos
  //   this.filteredContacts = [...this.contacts];

  //   // Actualizamos filteredContacts cuando cambia el input
  //   this.contactCtrl.valueChanges.subscribe(val => {
  //     if (!val) {
  //       this.filteredContacts = [...this.contacts];
  //     } else {
  //       const filterValue = typeof val === 'string' ? val.toLowerCase() : val.companyName.toLowerCase();
  //       this.filteredContacts = this.contacts.filter(c =>
  //         c.companyName.toLowerCase().includes(filterValue)
  //       );
  //     }
  //   });

  //   // Guardamos el UID al seleccionar un contacto
  //   this.contactCtrl.valueChanges.subscribe(val => {
  //     if (typeof val === 'object' && val && val.uid) {
  //       this.form.get('contactUid').setValue(val.uid);
  //     }
  //   });

  //   this.loadEmployees();
  // }

  // displayContact(contact: ContactModel): string {
  //   return contact && contact.companyName ? contact.companyName : '';
  // }

  // loadEmployees() {
  //   this.employeeService.getList()
  //     .then(res => this.employees = res || [])
  //     .catch(() => this.employees = []);
  // }

  // getDefaultStartTime(date: Date): string {
  //   const d = new Date(date);
  //   const hh = ('0' + (d.getHours() === 0 ? 9 : d.getHours())).slice(-2);
  //   const mm = ('0' + d.getMinutes()).slice(-2);
  //   return `${hh}:${mm}`;
  // }

  // getDefaultEndTime(date: Date): string {
  //   const d = new Date(date);
  //   const hours = d.getHours() === 0 ? 9 : d.getHours();
  //   const minutes = d.getMinutes() + 30;
  //   d.setHours(hours);
  //   d.setMinutes(minutes);
  //   const hh = ('0' + d.getHours()).slice(-2);
  //   const mm = ('0' + d.getMinutes()).slice(-2);
  //   return `${hh}:${mm}`;
  // }

  // onCancel(): void {
  //   // this.dialogRef.close();
  // }

  // async onSave(): Promise<void> {
  //   if (this.form.invalid) return;

  //   this.loading = true;
  //   try {
  //     const { conceptUid, contactUid, employeeId, date, startTime, endTime, notes } = this.form.value;

  //     const startDateTime = new Date(date);
  //     const [startH, startM] = startTime.split(':').map(x => +x);
  //     startDateTime.setHours(startH, startM, 0, 0);

  //     const endDateTime = new Date(date);
  //     const [endH, endM] = endTime.split(':').map(x => +x);
  //     endDateTime.setHours(endH, endM, 0, 0);

  //     const appointment = new AppointmentModel();
  //     appointment.conceptUid = conceptUid;
  //     appointment.employeeId = employeeId;
  //     appointment.contactUid = contactUid;
  //     appointment.startTime = this.toUtc(startDateTime);
  //     appointment.endTime = this.toUtc(endDateTime);
  //     appointment.notes = notes;
  //     appointment.isAllDay = false;

  //     const saved = await this.agendaProService.createAppointment(appointment);
  //     // if (saved) this.dialogRef.close();
  //     // else alert('Error al guardar la cita');

  //   } catch (error) {
  //     console.error('Error al guardar cita:', error);
  //     alert('Error al guardar la cita');
  //   } finally {
  //     this.loading = false;
  //   }
  // }

  // private toUtc(date: Date): Date {
  //   return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  // }
  public trackByIndex(i: number) { return i; }

}
